module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "max-width": "500px",
      "persistent": ""
    },
    on: {
      "update:returnValue": _vm.setEditItemIdZero
    },
    model: {
      value: (_vm.dialogResult),
      callback: function($$v) {
        _vm.dialogResult = $$v
      },
      expression: "dialogResult"
    }
  }, [_c('v-card', [_c('v-card-text', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "loading": _vm.loading.plan,
      "label": "Name"
    },
    model: {
      value: (_vm.itemData.name),
      callback: function($$v) {
        _vm.$set(_vm.itemData, "name", $$v)
      },
      expression: "itemData.name"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "loading": _vm.loading.plan,
      "label": "Price",
      "prefix": "$",
      "suffix": _vm.selectedCasket ? '(includes casket price $ ' + _vm.casketById(_vm.selectedCasket).price + ')' : ''
    },
    model: {
      value: (_vm.itemData.price),
      callback: function($$v) {
        _vm.$set(_vm.itemData, "price", $$v)
      },
      expression: "itemData.price"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.allCaskets,
      "loading": _vm.loading.plan,
      "clearable": "",
      "label": "Select Casket Model"
    },
    model: {
      value: (_vm.selectedCasket),
      callback: function($$v) {
        _vm.selectedCasket = $$v
      },
      expression: "selectedCasket"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md12": ""
    }
  }, [_c('v-combobox', {
    attrs: {
      "items": _vm.products,
      "loading": _vm.loading.plan,
      "hide-selected": "",
      "multiple": "",
      "persistent-hint": "",
      "small-chips": "",
      "label": "Select Products"
    },
    model: {
      value: (_vm.selectedServices),
      callback: function($$v) {
        _vm.selectedServices = $$v
      },
      expression: "selectedServices"
    }
  })], 1), _vm._v(" "), (_vm.selectedServices && _vm.selectedServices.length) ? _c('v-data-table', {
    attrs: {
      "items": _vm.selectedServices,
      "headers": _vm.productsTableHeaders,
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.name))]), _vm._v(" "), _c('td', {
          staticClass: "quantity_bgcolor"
        }, [_c('v-edit-dialog', {
          attrs: {
            "return-value": props.item.amount,
            "large": "",
            "lazy": "",
            "persistent": ""
          },
          on: {
            "update:returnValue": function($event) {
              return _vm.$set(props.item, "amount", $event)
            },
            "update:return-value": function($event) {
              return _vm.$set(props.item, "amount", $event)
            }
          },
          scopedSlots: _vm._u([{
            key: "input",
            fn: function() {
              return [_c('v-text-field', {
                attrs: {
                  "label": "Quantity",
                  "single-line": "",
                  "autofocus": ""
                },
                model: {
                  value: (props.item.amount),
                  callback: function($$v) {
                    _vm.$set(props.item, "amount", $$v)
                  },
                  expression: "props.item.amount"
                }
              })]
            },
            proxy: true
          }], null, true)
        }, [_c('div', [_vm._v(_vm._s(props.item.amount))])])], 1), _vm._v(" "), _c('td', [_vm._v("$" + _vm._s(props.item.price))]), _vm._v(" "), _c('td', [_vm._v("$" + _vm._s(props.item.amount * props.item.price))])]
      }
    }], null, false, 399487055)
  }) : _vm._e()], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.editItemDataDecorator($event)
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.dialogClose($event)
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "hide-overlay": "",
      "persistent": "",
      "width": "300"
    },
    model: {
      value: (_vm.showAlert),
      callback: function($$v) {
        _vm.showAlert = $$v
      },
      expression: "showAlert"
    }
  }, [_c('v-card', {
    attrs: {
      "color": "primary",
      "dark": ""
    }
  }, [_c('v-card-text', {
    staticClass: "flex-alert-center"
  }, [_c('v-icon', {
    staticClass: "flex-alert-notification-check",
    attrs: {
      "dark": "",
      "right": ""
    }
  }, [_vm._v("error")]), _vm._v(" " + _vm._s(_vm.alertMessage) + "\n      ")], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ad718c2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialogs/AppEditPlansDialog.vue
// module id = 994
// module chunks = 1